import { useLayoutEffect, useRef, useState } from "react";
/** The route/request owns visibility; a previous animation can never close a new opening. */
export function useAnimatedDrawer(requested: string | null) {
  const [id, setId] = useState(requested);
  const [closing, setClosing] = useState(false);
  const generation = useRef(0);
  useLayoutEffect(() => {
    const current = ++generation.current;
    if (requested) {
      setId(requested);
      setClosing(false);
      return;
    }
    if (!id) return;
    setClosing(true);
    const timer = setTimeout(() => {
      if (generation.current === current) {
        setId(null);
        setClosing(false);
      }
    }, 250);
    return () => {
      ++generation.current;
      clearTimeout(timer);
    };
  }, [requested, id]);
  return { id, closing };
}
